import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CONTEXTUAL_VIDEO_REPORT_ID } from './contextualVideoReportId';

// columns that can be selectively toggled 'On' and 'Off' in the custom columns view
const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.VIEWABILITY_RATE_VS_AVG.field,
        FIELDS.COMPLETION_RATE_VS_AVG.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.COMPLETED_VIEWS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.VIEWABILITY_RATE.field,
        FIELDS.COMPLETION_RATE.field,
    ].map(field => generateColumnId(CONTEXTUAL_VIDEO_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.CONTEXT.field,
    FIELDS.IMPRESSIONS.field,
    FIELDS.IMPRESSIONS_PCT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.COMPLETED_VIEWS.field,
    FIELDS.VIEWABILITY_RATE.field,
    FIELDS.COMPLETION_RATE.field,
    FIELDS.VIEWABILITY_RATE_VS_AVG.field,
    FIELDS.COMPLETION_RATE_VS_AVG.field,
].map(field => generateColumnId(CONTEXTUAL_VIDEO_REPORT_ID, field));

export { customColumns, defaultColumns };
